import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star } from 'lucide-react';

const Footer = () => {
  return (
    <motion.footer 
      className="bg-[#350a06]/90 backdrop-blur-md border-t border-red-500/30 py-8"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-6 text-center">
        <div className="flex justify-center items-center gap-2 mb-4">
          <Star className="w-5 h-5 text-yellow-400" />
          <span className="text-yellow-300">Profesor Juan de la Cruz © 2025</span>
          <Heart className="w-5 h-5 text-red-400" />
        </div>
        <p className="text-yellow-300/60 text-sm">
          Con amor y magia para tu camino espiritual.
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;
